import React, { useEffect, useState } from 'react'
import Layout from '../../brands/components/Layout'
import { Dropdown } from 'react-bootstrap'
import { Icon } from '@iconify/react'
import { useNavigate } from 'react-router-dom'
import './index.css'
import CreateFolder from '../components/AddFolderModal'
import DelFolder from '../components/DelFormModal'
import { useAppDispatch, useAppSelector } from '../../../redux/hook'
import { HIDE_LOADER, SHOW_LOADER } from '../../../redux/slices/LoaderSlice'
import { getAllPrograms } from '../api'
import { programlist } from '../slice/trainingslice'
import { Training } from '../slice/type'
import EditProgram from '../components/EditFolderModal'
import { Button } from '../../../../src/components'

const Resources: React.FC = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const { trainingList } = useAppSelector((state) => state.admintraining)
    const [showCreateFolder, setShowCreateFolder] = useState<boolean>(false)
    const [showDelFolder, setShowDelFolder] = useState<boolean>(false)
    const [showeditProogram, setShowEditProgram] = useState<boolean>(false)
    const [seletedProgram, setSelectedProgram] = useState<Training | null>(null)
    const [programid, setProgramId] = useState<string>('')
    const [currentPage] = useState<number>(1)

    useEffect(() => {
        dispatch(SHOW_LOADER())
        const fetchData = async () => {
            try {
                const programData = await getAllPrograms()
                // Dispatch the action with the data if needed
                dispatch(
                    programlist({
                        data: programData.data?.data.map(
                            (program: Training) => ({
                                ...program,
                                editable: false,
                            })
                        ),
                        totalCount: programData.data.totalCount,
                        pageSize: programData.data.pageSize,
                    })
                )
                dispatch(HIDE_LOADER())
            } catch (err) {
                console.error('Error fetching holidays:', err)
            }
        }
        fetchData()
    }, [currentPage])

    return (
        <div>
            <CreateFolder
                show={showCreateFolder}
                onClose={setShowCreateFolder}
            />
            <DelFolder
                show={showDelFolder}
                onClose={setShowDelFolder}
                data={{ id: programid }}
            />
            <EditProgram
                show={showeditProogram}
                onClose={setShowEditProgram}
                data={seletedProgram ? seletedProgram : { title: '', id: '' }}
            />

            <Layout custom={true}>
                <div className="col-12 grid-custom-table">
                    <div className="page-information mb-3">
                        <div className="d-flex justify-content-between">
                            <div>
                                <h4>Training Programs</h4>
                            </div>
                            <div>
                                <div className="button-block ">
                                    <Button
                                        onClick={() =>
                                            setShowCreateFolder(true)
                                        }
                                    >
                                        CREATE TRAINING PROGRAM
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="custom-table resources">
                        {trainingList?.length > 0 ? (
                            <table>
                                <tr>
                                    <th>Title</th>
                                    <th></th>
                                    <th>Actions</th>
                                </tr>

                                {trainingList?.map((training: Training) => {
                                    return (
                                        <tr key={training.id}>
                                            <td>
                                                <span
                                                    onClick={() =>
                                                        navigate(
                                                            `/resources/view/${training.id}?resource=${training.title}`,
                                                            {
                                                                state: {
                                                                    resourcename:
                                                                        training.title,
                                                                    id: training.id,
                                                                },
                                                            }
                                                        )
                                                    }
                                                    style={{
                                                        cursor: 'pointer',
                                                    }}
                                                >
                                                    {' '}
                                                    {training.title}
                                                </span>
                                            </td>
                                            <td>
                                                {' '}
                                                <div className="dropdown-assigned-value">
                                                    Completed by{' '}
                                                    <Dropdown className="assigned-dropdown dropdown-custom-link">
                                                        <Dropdown.Toggle
                                                            variant="success"
                                                            id="dropdown-basic"
                                                        >
                                                            {training
                                                                .programStats
                                                                ?.completedBy
                                                                ?.length ?? 0}
                                                        </Dropdown.Toggle>

                                                        <Dropdown.Menu>
                                                            <Dropdown.Item>
                                                                <b>
                                                                    Completed
                                                                    By:
                                                                </b>
                                                            </Dropdown.Item>

                                                            {training.programStats?.completedBy?.map(
                                                                (
                                                                    user: string,
                                                                    index: number
                                                                ) => (
                                                                    <Dropdown.Item
                                                                        key={`${user}-${index}`}
                                                                    >
                                                                        {user}
                                                                    </Dropdown.Item>
                                                                )
                                                            )}
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                    /{' '}
                                                    <Dropdown className="assigned-dropdown dropdown-custom-link">
                                                        <Dropdown.Toggle
                                                            variant="success"
                                                            id="dropdown-basic"
                                                        >
                                                            {training
                                                                .programStats
                                                                ?.assignedTo
                                                                ?.length ?? 0}
                                                        </Dropdown.Toggle>

                                                        <Dropdown.Menu>
                                                            <Dropdown.Item>
                                                                <b>
                                                                    Assigned To:
                                                                </b>
                                                            </Dropdown.Item>
                                                            {training.programStats?.assignedTo?.map(
                                                                (
                                                                    user: string,
                                                                    index: number
                                                                ) => (
                                                                    <Dropdown.Item
                                                                        key={`${user}-${index}`}
                                                                    >
                                                                        {user}
                                                                    </Dropdown.Item>
                                                                )
                                                            )}
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                    assigned employees
                                                </div>
                                            </td>
                                            <td>
                                                <div className="dropdown-custom-link">
                                                    {' '}
                                                    <Dropdown>
                                                        <Dropdown.Toggle
                                                            variant="success"
                                                            id="dropdown-basic"
                                                        >
                                                            <Icon icon="mage:dots" />
                                                        </Dropdown.Toggle>

                                                        <Dropdown.Menu>
                                                            <Dropdown.Item
                                                                onClick={() => {
                                                                    setSelectedProgram(
                                                                        training
                                                                    )
                                                                    setShowEditProgram(
                                                                        true
                                                                    )
                                                                }}
                                                            >
                                                                Edit
                                                            </Dropdown.Item>
                                                            <Dropdown.Item
                                                                onClick={() => {
                                                                    setShowDelFolder(
                                                                        true
                                                                    )
                                                                    setProgramId(
                                                                        training.id
                                                                    )
                                                                }}
                                                            >
                                                                Delete
                                                            </Dropdown.Item>
                                                            <Dropdown.Item
                                                                onClick={() =>
                                                                    navigate(
                                                                        '/resources/assign',
                                                                        {
                                                                            state: {
                                                                                id: training.id,
                                                                                programName:
                                                                                    training.title,
                                                                            },
                                                                        }
                                                                    )
                                                                }
                                                            >
                                                                Assign
                                                            </Dropdown.Item>
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </div>
                                            </td>
                                        </tr>
                                    )
                                })}
                            </table>
                        ) : (
                            <div className="no-records">No records found</div>
                        )}
                    </div>
                    <></>
                </div>
            </Layout>
        </div>
    )
}

export default Resources
